export class InvitoTecnico {
    nome: string = "";
    cognome: string = "";
    email: string = "";
    assegnaPratichePrecedenti: boolean = false;
    societaId: number = 0;
}